import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import { useStyles, StyledTableCell, StyledTableRow } from './ServiceTabTwoStyle'
import icons_storage from '../../../../assets/icons/icons_storage.png';
import clarity_backup from '../../../../assets/icons/clarity_backup.png';
import ram from '../../../../assets/icons/ram3x.png';
import storage from '../../../../assets/icons/storage.png';
import cpu from '../../../../assets/icons/cpu.png';

const TableComponent = () => {
    const classes = useStyles();
    return (
        <TableContainer component={Paper} className={classes.tabContainer}>
            <Table className={classes.table} size="medium" aria-label="customized table">
                <TableBody>
                    {
                        [1, 2, 3, 4, 5].map(item => {
                            return (
                                <StyledTableRow >
                                    <StyledTableCell component="th" scope="row">
                                        <div className={classes.tabContainerOne}>
                                            <div className={classes.cellContainer}>
                                                <div>
                                                    <p className={classes.tabHeadText}>Business-1</p>
                                                    <div className={classes.tabInnerTextDivContainer}>
                                                        <div className={classes.tabInnerTextDiv}>
                                                            <img src={cpu} width={16} height={16} style={{ marginRight: 5 }} alt='img' />
                                                            <p className={classes.tabInnerText}>1 Cup</p>
                                                        </div>
                                                        <div className={classes.tabInnerTextDiv}>
                                                            <img src={ram} width={14} height={14} style={{ marginRight: 5 }} alt='img' />
                                                            <p className={classes.tabInnerText}>4GB RAM</p>
                                                        </div>
                                                        <div className={classes.tabInnerTextDiv}>
                                                            <img src={storage} width={16} height={16} style={{ marginRight: 5 }} alt='img' />
                                                            <p className={classes.tabInnerText}>600GB Storage (200 GB/Node)</p>
                                                        </div>
                                                        <div className={classes.tabInnerTextDiv}>
                                                            <img src={clarity_backup} width={16} height={16} style={{ marginRight: 5 }} alt='img' />
                                                            <p className={classes.tabInnerText}>No Backups</p>
                                                        </div>
                                                        <div className={classes.tabInnerTextDiv}>
                                                            <img src={icons_storage} width={16} height={16} style={{ marginRight: 5 }} alt='img' />
                                                            <p className={classes.tabInnerText}>3-Node Hight Availability Set</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className={classes.priceText}>$600/ Month</p>

                                            </div>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default function ServiceTabTwo() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    return (
        <div className={classes.root}>
            <AppBar elevation={0} position="static" color="default" className={classes.appBar}>
                <div className={'tabsRow'}>
                    <div onClick={() => setValue(0)} className={value === 0 ? classes.selected : classes.notSelected}><p className={value !== 0 ? classes.tabHead : classes.activeTab}>Startup</p></div>
                    <div onClick={() => setValue(1)} className={value === 1 ? classes.selected : classes.notSelected}><p className={value !== 1 ? classes.tabHead : classes.activeTab}>Business</p></div>
                    <div onClick={() => setValue(2)} className={value === 2 ? classes.selected : classes.notSelected}><p className={value !== 2 ? classes.tabHead : classes.activeTab}>Premium</p></div>
                </div>
            </AppBar>
            <>
                <p className={classes.heading}>For test environments with high performance needs. Please refer to the  plan comparison  for more information.</p>
                {
                    value === 0
                        ?
                        <TableComponent />
                        :
                        value === 1
                            ?
                            <TableComponent />
                            :
                            value === 2
                                ?
                                <TableComponent />

                                :
                                null
                }
            </>
        </div>
    );
}
